import { Directive, HostListener, ElementRef } from '@angular/core';
import { PageProvider } from '../../providers/page/page';
import { NavController } from 'ionic-angular';

/**
 * Generated class for the NavPageDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[nav-page]' // Attribute selector
})
export class NavPageDirective {
  private href: string;
  constructor(el: ElementRef, private pages: PageProvider, private navCtrl: NavController) {
    this.href = el.nativeElement.getAttribute('href');
  }
  @HostListener('click', ['$event']) onClick($event){
    // console.log(this.href);
    const page = this.pages.getPage(this.href);
    if(page){
      this.navCtrl.push(page);
    }
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/directives/nav-page/nav-page.ts